const ABFieldImageCore = require("../../core/dataFields/ABFieldImageCore");
module.exports = class ABFieldImage extends ABFieldImageCore {};
